import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CurriculumSelector from "../component/CurriculumSelector";
import axios from "axios";
import { server2 } from "../constant/config";
import Layout from "../layout/Layout";
import { useAuthConfig } from "../hooks/useAuthConfig";

const AddOrUpdateKunjiReleaseDate = () => {
  const config = useAuthConfig();
  const [searchParams] = useSearchParams();
  const boardId = Number(searchParams.get("board_id"));
  const classId = Number(searchParams.get("class_id"));
  const subjectId = Number(searchParams.get("subject_id"));
  const releaseId = Number(searchParams.get("id"));
  const edit = searchParams.get("edit") === "true";

  const [data, setData] = useState({
    board_id: boardId || "",
    class_id: classId || "",
    subject_id: subjectId || "",
    release_id: releaseId || "",
    chapter_id: "",
    topic_id: "",
  });

  const [releaseDate, setReleaseDate] = useState("");
  const [year, setYear] = useState("");

  // Handle curriculum selections
  const handleCurriculumChange = useCallback((selections) => {
    setData((prev) => ({
      ...prev,
      board_id: selections.board || "",
      class_id: selections.class || "",
      subject_id: selections.subject || "",
      chapter_id: selections.chapter || "",
      topic_id: selections.topic || "",
    }));
  }, []);

  const handleSubmit = async (e) => {
      e.preventDefault();
    if (
      !data.board_id ||
      !data.class_id ||
      !data.subject_id ||
      !data.chapter_id ||
      !releaseDate || !year
    ) {
      alert("Please fill in all fields.");
      return;
    }

    const payload = {
      board_id: data.board_id,
      class_id: data.class_id,
      subject_id: data.subject_id,
      chapter_id: parseInt(data.chapter_id, 10),
      year: parseInt(year, 10),
      release_date: releaseDate
        ? new Date(releaseDate).toISOString().split("T")[0]
        : "",
    };

    try {
      if (edit) {
        // Update existing
        const response = await axios.patch(
          `${server2}/v1/kunjireleasedates/${releaseId}`,
          payload,
          config
        );
        alert("Kunji Release Date updated successfully!");
      } else {
        // Add new
        const response = await axios.post(
          `${server2}/v1/kunjireleasedates`,
          payload,
          config
        );
        alert("Kunji Release Date added successfully!");
      }
    } catch (error) {
      console.error("Error saving Kunji Release Date:", error);
      alert("Failed to save Kunji Release Date. Please try again.");
    }
  };

  return (
 <Layout>   <div className="container mx-auto p-6 bg-white shadow rounded">
 <h1 className="text-2xl font-bold mb-6">
   {edit ? "Edit Kunji Release Date" : "Add Kunji Release Date"}
 </h1>

 <form onSubmit={handleSubmit} className="space-y-6">
   {/* Curriculum Selector */}
   <CurriculumSelector
     initialSelections={{
       board: data.board_id,
       class: data.class_id,
       subject: data.subject_id,
       chapter: data.chapter_id,
       topic: data.topic_id,
     }}
     onChange={handleCurriculumChange}
   />

   {/* Release Date */}
   <div>
     <label className="block text-sm font-medium mb-1">Release Date</label>
     <input
       type="date"
       className="w-full border rounded p-2"
       value={releaseDate}
       onChange={(e) => setReleaseDate(e.target.value)}
       required
     />
   </div>

   {/* Year */}
   <div>
     <label className="block text-sm font-medium mb-1">Year</label>
     <input
       type="number"
       className="w-full border rounded p-2"
       value={year}
       onChange={(e) => setYear(e.target.value)}
     />
   </div>

   {/* Submit */}
   <button
     type="submit"
     className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
   >
     {edit ? "Update" : "Add"}
   </button>
 </form>
</div></Layout>
  );
};

export default AddOrUpdateKunjiReleaseDate;
